import { CommonWrapper } from 'styles/common/Layout';
import QRScanImage from "assets/images/qrscan.png";

import {
  Background,
} from 'styles/components/home/QRInfoStyle';
import useAuthStore from 'store/auth';
import QRCode from 'qrcode';
import { useEffect, useRef } from 'react';

function QRInfo() {
  const { user } = useAuthStore();
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    QRCode.toCanvas(canvas, user?.sid, { width: 180 }, (error) => {
      if (error) console.error(error);
      console.log('QR Code generated!');
    });
  }, [user]);

  
  return (
    <Background>
      <CommonWrapper className="text-center">
        <div>
          <canvas id="canvas" ref={canvasRef}></canvas>
        </div>
		<div>
          <img
			src={QRScanImage}
			alt=""
			style={{ width: "80%", marginBottom: "10px" }}
		  />
        </div>
      </CommonWrapper>
    </Background>
  );
}

export default QRInfo;
